@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Rhode Island</h2>
  @if ((baseRules?.["individual_text"] || "").includes("show")) {  
           <div class="axis-form-group _mt-medium _ml-large">
              <div class="axis-col-sm-12 axis-col-lg-12">
                <label class="axis-control-label"> {{ textValues?.individual_text }} </label>
              </div>
          </div>
      }
  @if ((baseRules?.["Bodily_Injury_text"] || "").includes("show")) {  
           <div class="axis-form-group _mt-medium _ml-large">
              <div class="axis-col-sm-12 axis-col-lg-12">
                <label class="axis-control-label"> {{ textValues?.Bodily_Injury_text }} </label>
              </div>
          </div>
      }
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <!-- UM Radio Group level One -->
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <!-- UM Radio Group level two -->
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium _ml-large"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <!-- UM Radio Group level three -->
      @if (controls?.length >= 3) {
        <div
          class="axis-form-group _mt-medium _ml-large"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[2].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[2].formControlName)?.touched &&
              reactiveForm.get(controls[2].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
            @for (control of controls[2].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[2].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[2].formControlName)?.touched) {
            @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <!-- Liability Limit-->
      <div class="axis-grid _ml-large">
        @if ((baseRules?.["UM_LiabilityLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[14].label }}</label>
              <div id="um_liabilitylimit_Limit_equal_to_the_limit_of_my_Bodily_Injury_Liability_Coverage-pdffield-rhode-island">
                {{ controls[14].data[0].name }}
              </div>
            </div>
          </div>
        }
      </div>
      <!-- UM Dropdowns -->
      <div class="axis-grid _ml-large">
        @for (control of controls | slice: 3; track $index) {
            @if (baseRules[control.baseRuleKey]?.includes("show")) {
              <div class="axis-col-6">
                <div
                  class="axis-form-group"
                  [ngClass]="{
                    'has-axis-required':
                      reactiveForm.get(control.formControlName)?.value === null ||
                      reactiveForm.get(control.formControlName)?.value === '',
                    'has-axis-error':
                      reactiveForm.get(control.formControlName)?.touched &&
                      reactiveForm.get(control.formControlName)?.invalid,
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="{{ control.formControlName }}"
                  >
                    {{ control.label }}
                  </label>
                  <axis-dropdown
                    (onSelect)="control.selectedPremium = $event.premium"
                    [dataProvider]="control.data"
                    id="{{ control.formControlName }}"
                    formControlName="{{ control.formControlName }}"
                  ></axis-dropdown>
                  @if (reactiveForm.get(control.formControlName)?.touched) {
                    @if (reactiveForm.get(control.formControlName)?.invalid) {
                      <span
                        class="axis-error-block"
                        role="alert"
                        >Please select an option.</span
                      >
                    }
                  }
                  @if (control.selectedPremium) {
                    <div [hidden]="!showPremium">Premium: {{ control.selectedPremium }}</div>
                  }
                </div>
              </div>
            }
        }
      </div>

      <div class="axis-grid _ml-large">
      @if ((baseRules?.["RejectUMUIMBIMinLimit_DropDown"] || "").includes("readonly")) {
              <div class="axis-col-sm-6 axis-col-lg-6">
                <div class="axis-form-group">
                  <label class="axis-control-label">{{ controls[12].label }}</label>
                  <div id="rejectumuimbiminlimit_50k-pdffield-rhode-island">
                    {{ controls[12].data[0].name }}
                  </div>
                </div>
              </div>
      }
      @if ((baseRules?.["RejectUMUIMBISplitMinLimit_DropDown"] || "").includes("readonly")) {
        <div class="axis-col-sm-6 axis-col-lg-6">
              <div class="axis-form-group">
                  <label class="axis-control-label">{{ controls[11].label }}</label>
                  <div id="rejectumuimbisplitminlimit_25k_50k-pdffield-rhode-island">
                    {{ controls[11].data[0].name }}
                  </div>
              </div>
          </div>
      }
      </div>
      <div class="axis-grid _ml-large">
      @if ((baseRules?.["SelectUMUIMBIMinLimit_DropDown"] || "").includes("readonly")) {
        <div class="axis-col-sm-6 axis-col-lg-6">
              <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[9].label }}</label>
                <div id="selectumuimbiminlimit_50k-pdffield-rhode-island">
                  {{ controls[9].data[0].name }}
                </div>
            </div>
          </div>
      }
      @if ((baseRules?.["SelectUMUIMBIMinLimits_DropDown"] || "").includes("readonly")) {
        <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[8].label }}</label>
                <div id="selectumuimbiminlimits_25k_50k-pdffield-rhode-island">
                  {{ controls[8].data[0].name }}
                </div>
            </div>
          </div>
      }
      @if ((baseRules?.["SelectUMUIMPDMinLimit_DropDown"] || "").includes("readonly")) {
        <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[10].label }}</label>
                <div id="selectumuimpdminlimit_25k-pdffield-rhode-island">
                  {{ controls[10].data[0].name }}
                </div>
            </div>
          </div>
      }
      </div>
       @if (
        (baseRules?.selectionId === "Below_75k_Selectmin_Varybetween" ) ||
        (baseRules?.selectionId === "Above_75k_Reject_Reject_Varybetween" ) ||
        (baseRules?.selectionId === "Above_75k_Individual_Reject_Csl" ) ||
        (baseRules?.selectionId === "Above_75k_Individual_Reject_Split" ) ||
        (baseRules?.selectionId === "Above_75k_Individual_Reject_Varybetween" ) 
        ) 
       {  
           <div class="axis-form-group _mt-medium _ml-large">
              <div class="axis-col-sm-12 axis-col-lg-12">
                <label class="axis-control-label"
                id="rejectumuimbilimits_levelthree_radio-pdffield-rhode-island"> {{ textValues?.Reject_Text_UMPD }} </label>
              </div>
          </div>
        }
        @if ((baseRules?.["Reject_LevelTwo_Radio"] || "").includes("Yes")) {  
           <div class="axis-form-group _mt-medium _ml-large">
              <div class="axis-col-sm-12 axis-col-lg-12">
                <label class="axis-control-label"
                id="selectminlimit_levelone_radio-pdffield-rhode-island"> {{ textValues?.RI_Reject_UMUIM }} </label>
              </div>
          </div>
      }
        
    </form>
    <p>{{ textValues?.description }}</p>
  }
}
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Rhode Island</h2>
  <!-- DROPDOWN VALUES -->
  <div class="axis-grid">
    @for (control of controls | slice: 8; track $index) {
      @if (baseRules[control.baseRuleKey]) {
        <div class="axis-col-sm-6 axis-col-lg-4">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ control.label }}</label>
            <div>{{ control.data[0].name }}</div>
          </div>
        </div>
      }
    }
  </div>

  @if ((baseRules?.["SelectMinLimit_LevelOne_Radio"] || "").includes("Yes")) { 
    <div class="axis-grid"> 
           <div class="axis-form-group _mt-medium">
              <div class="axis-col-sm-12 axis-col-lg-12">
                <label class="axis-control-label"
                id="selectminlimit_levelone_radio-pdffield-rhode-island"> {{ textValues?.RI_Reject_UMUIM }} </label>
              </div>
          </div>
          </div>
      }
      @if ((baseRules?.["RejectUMUIMBILimits_LevelThree_Radio"] || "").includes("Yes")) { 
        <div class="axis-grid"> 
           <div class="axis-form-group">
              <div class="axis-col-sm-12 axis-col-lg-12">
                <label class="axis-control-label"
                id="rejectumuimbilimits_levelthree_radio-pdffield-rhode-island"> {{ textValues?.Reject_Text_UMPD }} </label>
              </div>
          </div>
          </div>

        }
}
